import React, { useState, memo, useEffect } from 'react';
import {
  Eye, EyeOff, Mail, Lock, ArrowRight, Shield,
  AlertCircle, CheckCircle2, X, User
} from 'lucide-react';
import logoFedelza from '../../assets/logo-fedelza.png';
import { authService } from '../../services/authService';
import tokenStorage from '../../services/tokenStorage';
import { useNavigate } from 'react-router-dom';


export default function LoginPage({ onLogin, setActivePage }) {
  const [identificationNumber, setIdentificationNumber] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [codigo, setCodigo] = useState(['', '', '', '', '', '']);
  const [verificando, setVerificando] = useState(false);
  const [clientIp, setClientIp] = useState('');
  

  
  // Estados para modal de recuperación
  const [showRecovery, setShowRecovery] = useState(false);
  const [recEmail, setRecEmail] = useState('');
  const [recMensaje, setRecMensaje] = useState('');
  const [recIdentificationNumber, setRecIdentificationNumber] = useState('');
  const [recLoading, setRecLoading] = useState(false);
 
  

  const FedelzaLogo = memo(function FedelzaLogo() {
    return (
      <div className="relative mx-auto w-fit">
        <div
          aria-hidden
          className="absolute -inset-6 -z-10 blur-2xl opacity-50"
          style={{
            background:
              'radial-gradient(60% 60% at 50% 40%, rgba(59,130,246,0.25), rgba(99,102,241,0.12) 40%, transparent 70%)'
          }}
        />
        <div className="inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 rounded-[22px] bg-white/95 ring-1 ring-slate-200 shadow-[0_8px_30px_rgba(2,6,23,0.12)] backdrop-blur">
          <div className="pointer-events-none absolute left-2 top-2 w-1/3 h-1/3 rounded-2xl opacity-40"
            style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.8), rgba(255,255,255,0))' }} />
          <img
            src={logoFedelza}
            alt="Fedelza – Plataforma de Facturación Electrónica"
            decoding="async"
            loading="eager"
            className="h-16 md:h-20 w-auto object-contain"
          />
        </div>
      </div>
    );
  });

  const handleCodigoChange = (index, value) => {
    if (value.length > 1) return;
    const onlyDigits = value.replace(/\D/g, '');
    const nuevo = [...codigo];
    nuevo[index] = onlyDigits;
    setCodigo(nuevo);
    if (onlyDigits && index < 5) {
      document.querySelector(`input[name="codigo-${index + 1}"]`)?.focus();
    }
  };

  const handleCodigoKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !codigo[index] && index > 0) {
      document.querySelector(`input[name="codigo-${index - 1}"]`)?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMensaje('');

    if (!identificationNumber?.trim()) {
      setError('Por favor ingresa tu número de identificación');
      return;
    }

    try {
      setIsLoading(true);

      const res = await authService.login({
        identificationNumber: identificationNumber.trim(),
        email,
        password
      });

      if (res?.statusCode === 200) {
        // Solo activar el modal OTP, el token y user vendrán después de verificar el OTP
        setShowOtpModal(true);
        setMensaje(res?.message || 'Te enviamos un código de verificación a tu correo');
        setTimeout(() => setMensaje(''), 6000);
        setTimeout(() => document.querySelector('input[name="codigo-0"]')?.focus(), 0);
      } else {
        setError(res?.message || 'Credenciales inválidas');
      }
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Error al iniciar sesión';
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  // ---------- Verificar OTP ----------
          useEffect(() => {
            let cancel = false;

            (async () => {
              try {
                // 1) IP pública
                const r = await fetch('https://api.ipify.org?format=json', { cache: 'no-store' });
                if (!cancel && r.ok) {
                  const { ip } = await r.json();
                  setClientIp(ip || '');
                  return;
                }
              } catch (_) {}

              try {
                // 2) Fallback: header X-Forwarded-For (si detrás de proxy propio)
                const r2 = await fetch('/api/whoami', { cache: 'no-store' });
                if (!cancel && r2.ok) {
                  const j = await r2.json();
                  setClientIp(j?.ip || '');
                  return;
                }
              } catch (_) {}

              // 3) Último recurso
              if (!cancel) setClientIp('0.0.0.0');
            })();

            return () => { cancel = true; };
          }, []);
            
            const handleVerifyOtp = async () => {
              try {
                setVerificando(true);
                setError('');
                setMensaje('');

                // Construir el código OTP del array - solo dígitos válidos
                const otpCode = codigo.filter(digit => digit && digit.trim() !== '').join('');
                
                console.log("🔍 Debug - Array codigo:", codigo);
                console.log("🔍 Debug - OTP construido:", otpCode);
                
                // Validar que el código esté completo
                if (otpCode.length !== 6) {
                  setError(`Por favor ingresa el código completo de 6 dígitos (tienes ${otpCode.length})`);
                  return;
                }

                // Validar que sean solo números
                if (!/^\d{6}$/.test(otpCode)) {
                  setError('El código debe contener solo números');
                  return;
                }

                const payload = {
                  identificationNumber: parseInt(identificationNumber, 10), // ✅ Número (ej: 4366537)
                  otp: parseInt(otpCode, 10), // ✅ Número de 6 dígitos (ej: 556227)
                  email, // ✅ String (ej: "jhoncarvajal88@gmail.com")
                  ip: clientIp, // ✅ String (ej: "10.1.23.56")
                };
                
                const res = await authService.verifyOtp(payload);

                if (res?.statusCode === 200 || res?.token) {
                 setMensaje(res?.message || '¡OTP verificado correctamente!');
                        
                 // El authService ya almacenó automáticamente el token
                   console.log('✅ Token almacenado por authService');
                        
                   if (onLogin && typeof onLogin === 'function') {
                     onLogin(res);
                       }

                     setTimeout(() => {
                      setShowOtpModal(false);
                          if (setActivePage && typeof setActivePage === 'function') {
                            setActivePage('dashboard');
                          } else {
                            window.location.reload();
                          }
                        }, 1500);
                        
                      } else {
                        setError(res?.message || 'Error al verificar OTP.');
                      }
                      
               } catch (err) {
                console.error('Error al verificar OTP:', err);
                const errorMessage = err?.response?.data?.message || err?.message || 'Error al verificar el código';
                setError(errorMessage);
              } finally {
                setVerificando(false);
              }
            };


  // ---------- Recuperación ----------
      
              const handleRecovery = async (e) => {
          e.preventDefault();
          setRecLoading(true);
          setRecMensaje('');
          
          try {
            // Validaciones
            if (!recEmail || !recEmail.includes('@')) {
              setRecMensaje('Por favor ingrese un correo electrónico válido');
              return;
            }
            
            if (!recIdentificationNumber?.trim()) {
              setRecMensaje('Por favor ingrese su número de identificación');
              return;
            }
          
          const res = await authService.recoverPassword({ 
            email: recEmail.trim(),
            identificationNumber: recIdentificationNumber.trim()
          });
          
          if (res?.statusCode === 200) {
             setRecMensaje('Si los datos son correctos, recibirá instrucciones para restablecer su contraseña');
             setRecEmail(''); 
             setRecIdentificationNumber('');
             setTimeout(() => {
             setShowRecovery(false);
             setRecMensaje('');
                }, 3000);
              } else {
                setRecMensaje(res?.message || 'Error al enviar la solicitud de recuperación');
              }
            } catch (error) {
              console.error('Error en recuperación:', error);
              const errorMsg = error?.response?.data?.message || error?.message || 'Error al procesar la solicitud';
              setRecMensaje(errorMsg);
            } finally {
              setRecLoading(false);
            }
          };




  return (
    <div className="h-screen overflow-hidden flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-indigo-900 relative">
      {/* Fondo */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-8 -left-8 w-72 h-72 bg-blue-500 rounded-full mix-blend-multiply blur-lg opacity-20 motion-safe:animate-pulse" />
        <div className="absolute -bottom-10 -right-8 w-72 h-72 bg-purple-500 rounded-full mix-blend-multiply blur-lg opacity-20 motion-safe:animate-pulse motion-safe:[animation-delay:2s]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-indigo-500 rounded-full mix-blend-multiply blur-md opacity-10 motion-safe:animate-pulse motion-safe:[animation-delay:4s]" />
      </div>

      <div className="relative z-10 w-full max-w-md px-4">
        {/* Header */}
        <div className="text-center mb-4">
          <div className="mb-4">
            <FedelzaLogo />
            <div className="w-16 h-0.5 bg-blue-400 rounded-full mx-auto mt-4" />
          </div>
          <div className="space-y-1">
            <h1 className="text-2xl font-bold text-white">Bienvenido de vuelta</h1>
            <p className="text-blue-200 text-sm">
              Sistema de <span className="text-orange-400 font-semibold">Facturación Electrónica</span>
            </p>
          </div>
        </div>

        {/* Card */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-5">
          <h2 className="text-lg font-bold text-gray-800 mb-3 text-center">Iniciar sesión</h2>

          {error && (
            <div role="alert" aria-live="assertive" className="flex items-center p-2 mb-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg">
              <AlertCircle className="w-3 h-3 mr-2" />
              {error}
            </div>
          )}

          {mensaje && (
            <div role="status" aria-live="polite" className="flex items-center p-2 mb-2 text-xs text-green-700 bg-green-50 border border-green-200 rounded-lg">
              <CheckCircle2 className="w-3 h-3 mr-2" />
              {mensaje}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="space-y-2">
              {/* Identificación */}
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="text"
                  inputMode="numeric"
                  className="w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm"
                  value={identificationNumber}
                  onChange={(e) => setIdentificationNumber(e.target.value)}
                  placeholder="Número de identificación"
                  required
                />
              </div>

              {/* Email */}
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type="email"
                  autoComplete="email"
                  className="w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Correo electrónico"
                  required
                />
              </div>

              {/* Password */}
              <div className="relative">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  autoComplete="current-password"
                  className="w-full pl-9 pr-10 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Contraseña"
                  required
                />
                <button
                  type="button"
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2.5 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              {isLoading ? (
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <>
                  Continuar
                  <ArrowRight className="w-4 h-4" />
                </>
              )}
            </button>
          </form>

          {/* Enlaces extra */}
          <div className="mt-3 space-y-2">
            <button onClick={() => setShowRecovery(true)} className="block w-full text-center text-xs text-blue-600 hover:text-blue-700 hover:underline font-medium">
              ¿Olvidaste tu contraseña?
            </button>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t border-gray-300" />
              </div>
              <div className="relative flex justify-center text-xs">
                <span className="px-2 bg-white text-gray-500">¿No tienes cuenta?</span>
              </div>
            </div>

            <button onClick={() => setActivePage?.('datosc')} className="w-full border-2 border-blue-600 text-blue-600 py-2 px-4 rounded-lg font-semibold hover:bg-blue-50 transition-all duration-200 text-sm">
              Crear cuenta nueva
            </button>
          </div>
        </div>
      </div>

      {/* MODAL OTP */}
      {showOtpModal && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true" aria-labelledby="otp-title">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-5 relative">
            <button
              onClick={() => { setShowOtpModal(false); setCodigo(['','','','','','']); }}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Cerrar verificación OTP"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="text-center mb-3">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-2">
                <Shield className="w-6 h-6 text-blue-600" />
              </div>
              <h3 id="otp-title" className="text-lg font-bold text-gray-800">Verificación de seguridad</h3>
              <p className="text-gray-600 text-xs">Ingresa el código de 6 dígitos enviado a tu correo</p>
            </div>

            {error && (
              <div role="alert" aria-live="assertive" className="flex items-center p-2 mb-2 text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg">
                <AlertCircle className="w-3 h-3 mr-2" />
                {error}
              </div>
            )}

            {mensaje && (
              <div role="status" aria-live="polite" className="flex items-center p-2 mb-2 text-xs text-green-700 bg-green-50 border border-green-200 rounded-lg">
                <CheckCircle2 className="w-3 h-3 mr-2" />
                {mensaje}
              </div>
            )}

            <form onSubmit={handleVerifyOtp} className="space-y-3">
              <div className="flex justify-center gap-2">
                {codigo.map((digit, index) => (
                  <input
                    key={index}
                    name={`codigo-${index}`}
                    type="text"
                    inputMode="numeric"
                    autoComplete={index === 0 ? 'one-time-code' : 'off'}
                    className="w-10 h-10 text-center text-lg font-bold border-2 border-gray-300 rounded-lg focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200"
                    value={digit}
                    onChange={(e) => handleCodigoChange(index, e.target.value)}
                    onKeyDown={(e) => handleCodigoKeyDown(index, e)}
                    onPaste={(e) => {
                      const paste = (e.clipboardData.getData('text') || '').replace(/\D/g, '').slice(0, 6).split('');
                      if (paste.length) {
                        const nuevo = Array(6).fill('');
                        for (let i = 0; i < 6; i++) nuevo[i] = paste[i] || '';
                        setCodigo(nuevo);
                        const last = Math.min(paste.length - 1, 5);
                        requestAnimationFrame(() => {
                          document.querySelector(`input[name="codigo-${last}"]`)?.focus();
                        });
                        e.preventDefault();
                      }
                    }}
                    maxLength={1}
                    autoFocus={index === 0}
                    aria-label={`Dígito ${index + 1} del código`}
                  />
                ))}
              </div>

              <button
                  type="button"
                  onClick={handleVerifyOtp}
                  disabled={verificando}
                  className="w-full rounded-lg bg-[#003865] text-white font-semibold py-2.5 disabled:opacity-50"
                >
                  {verificando ? 'Verificando…' : 'Confirmar código'}
                </button>

            </form>
          </div>
        </div>
      )}

          {/* Modal recuperación */}
          {showRecovery && (
            <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 p-4" role="dialog" aria-modal="true" aria-labelledby="recovery-title">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-5 relative">
            <button
              onClick={() => { setShowRecovery(false); setRecEmail(''); setRecMensaje(''); }}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
              aria-label="Cerrar recuperación de contraseña"
            >
              <X className="w-5 h-5" />
            </button>

            <div className="text-center mb-4">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <Mail className="w-5 h-5 text-blue-600" />
              </div>
              <h3 id="recovery-title" className="text-lg font-bold text-gray-800 mb-2">Recuperar contraseña</h3>
              <p className="text-gray-600 text-xs">Ingresa tu número de identificación y correo. Te enviaremos instrucciones para restablecer tu contraseña</p>
            </div>

            {recMensaje && (
              <div className={`flex items-center p-2 mb-3 text-xs rounded-lg ${
                recMensaje.includes('instrucciones') ? 'text-green-700 bg-green-50 border border-green-200' : 'text-red-700 bg-red-50 border border-red-200'
              }`} role="status" aria-live="polite">
                {recMensaje.includes('instrucciones') ? <CheckCircle2 className="w-3 h-3 mr-2" /> : <AlertCircle className="w-3 h-3 mr-2" />}
                {recMensaje}
              </div>
            )}

            <form onSubmit={handleRecovery} className="space-y-3">
                    {/* Campo Número de Identificación */}
              <div className="space-y-2">
                <label htmlFor="rec-identification" className="block text-sm font-medium text-gray-700">
                  Número de Identificación
                </label>
                <div className="relative">
                  <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                  <input
                    id="rec-identification"
                    type="text"
                    inputMode="numeric"
                    className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm"
                    placeholder="Ingresa tu número de identificación"
                    value={recIdentificationNumber}
                    onChange={(e) => setRecIdentificationNumber(e.target.value)}
                    required
                    autoFocus
                  />
                  </div>
                
                 <div className="relative">
                 <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                 <input
                  type="email"
                  autoComplete="email"
                  className="w-full pl-9 pr-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm"
                  placeholder="Correo electrónico registrado"
                  value={recEmail}
                  onChange={(e) => setRecEmail(e.target.value)}
                  required
                  autoFocus
                  />
                  </div>

                 <button type="submit" disabled={recLoading} className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2.5 px-4 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm">
                  {recLoading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Enviando...
                  </>
                ) : (
                  'Enviar instrucciones'
                )}
              </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}